import { render, staticRenderFns } from "./PlanPreview-company.vue?vue&type=template&id=1b96fa83"
import script from "./PlanPreview-company.vue?vue&type=script&lang=js"
export * from "./PlanPreview-company.vue?vue&type=script&lang=js"
import style0 from "./PlanPreview-company.vue?vue&type=style&index=0&id=1b96fa83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports